import React from 'react';
import StoryLayout from './StoryLayout';

const StoryDetail = () => {
    return <StoryLayout />;
};

export default StoryDetail;